import Vue from 'vue'
import App from './App.vue'
import router from './router'
//http
import http from './utils/http'
//rsa
import secret   from './utils/secret'
//日期
import dayjs from "dayjs"

import "./components/drag.js";

//数据加载中
import {showLoading,hideLoading} from './utils/loading'

import element from './plugins/element'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/reset.css'
import './assets/css/iconfont.css'

Vue.config.productionTip = false

Vue.use(element)
Vue.prototype.$http = http
Vue.prototype.$jsEncrypt  = secret
Vue.prototype.$dayjs = dayjs;
Vue.prototype.$showLoading=showLoading;
Vue.prototype.$hideLoading=hideLoading;

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
